import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cb1b9e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-logo" }
const _hoisted_3 = { class: "login-content-main" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-czyy" }, null, -1))
const _hoisted_5 = { class: "login-content-title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "mt10" }
const _hoisted_8 = { class: "login-copyright" }
const _hoisted_9 = { class: "mb5 login-copyright-company" }
const _hoisted_10 = { class: "login-copyright-msg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Account = _resolveComponent("Account")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString($setup.getThemeConfig.globalViceTitle), 1)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["login-content", { 'login-content-mobile': _ctx.tabsActiveName === 'mobile' }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("h4", _hoisted_5, _toDisplayString($setup.getThemeConfig.globalTitle), 1),
        (!_ctx.isScan)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_tabs, {
                modelValue: _ctx.tabsActiveName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabsActiveName) = $event)),
                onTabClick: $setup.onTabsClick
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tab_pane, {
                    label: _ctx.$t('message.label.one1'),
                    name: "account",
                    disabled: _ctx.tabsActiveName === 'account'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_Transition, { name: "el-zoom-in-center" }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_Account, null, null, 512), [
                            [_vShow, _ctx.isTabPaneShow]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label", "disabled"])
                ]),
                _: 1
              }, 8, ["modelValue", "onTabClick"]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_button, {
                  type: "text",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.link.one3')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "text",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.link.two4')), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('message.copyright.one5')), 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('message.copyright.two6')), 1)
    ])
  ]))
}